<template>
<!-- 管理者 -->
  <div class="container-fluid fixed-menu">
    <div class="row">
      <ul class="navbar-nav bd-navbar-nav flex-row">
        <li class="nav-item dropdown col-md-4">
          <!--#Issues3対応としてtoggle機能off <a class="nav-item nav-link dropdown-toggle" href="#" id="bd-versions" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">棚卸管理</a>-->
          <a class="nav-item nav-link dropdown-toggle" href="#" id="bd-versions" aria-haspopup="true" aria-expanded="false">棚卸管理</a>
          <div class="dropdown-menu dropdown-menu-left" aria-labelledby="bd-versions">
            <router-link :to="{ name: 'inventory-info-list' }" class="dropdown-item">棚卸情報一覧</router-link>
          </div>
        </li>
        <li class="nav-item dropdown col-md-4">
          <!--#Issues3対応としてtoggle機能off <a class="nav-item nav-link dropdown-toggle" href="#" id="bd-versions2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">帳簿管理</a>-->
          <a class="nav-item nav-link dropdown-toggle" href="#" id="bd-versions2" aria-haspopup="true" aria-expanded="false">帳簿管理</a>
          <div class="dropdown-menu dropdown-menu-left" aria-labelledby="bd-versions2">
            <router-link :to="{ name: 'inventory-target-file-list' }" class="dropdown-item">棚卸対象ファイル一覧</router-link>
          </div>
        </li>
        <li class="nav-item dropdown col-md-4">
          <!--#Issues3対応としてtoggle機能off <a class="nav-item nav-link dropdown-toggle" href="#" id="bd-versions3" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">マスタ設定</a>-->
          <a class="nav-item nav-link dropdown-toggle" href="#" id="bd-versions3" aria-haspopup="true" aria-expanded="false">マスタ設定</a>
          <div class="dropdown-menu dropdown-menu-left" aria-labelledby="bd-versions3">
            <router-link :to="{ name: 'enterprise-edit', params: { mode: 'update', enterpriseCode: this.$session.get('enterpriseCode')} }" class="dropdown-item">企業設定</router-link>
            <router-link :to="{ name: 'section-list' }" class="dropdown-item">拠点設定</router-link>
            <router-link :to="{ name: 'user-list' }" class="dropdown-item">ユーザ設定</router-link>
            <router-link :to="{ name: 'stock-data-set' }" class="dropdown-item">CSV取込設定</router-link>
            <!-- <a class="dropdown-item" href="/goodsInfoList">商品設定</a> -->
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'admin'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/components/partials/sub_headers/Admin.vue